import html2pdf from "html2pdf.js/dist/html2pdf.min";
import { jsPDF } from "jspdf";
import ReactDOMServer from "react-dom/server";
import aensaLogo from "assets/images/aensa/new_logo_aensa.png";

const MaxNumberRecords = 150;

const pdfJsxHeader = (name) => {
  const dateObject = new Date();
  const dateFormated = new Date().toLocaleDateString("en-IN");
  const _userData = JSON.parse(localStorage.getItem("userData"));

  return (
    <div>
      <table>
        <tr>
          <td border="5px" margin="10px">
            <img height={"100px"} width={"100px"} src={aensaLogo}></img>
          </td>
          <td>&nbsp;&nbsp;</td>
          <td border="5px" margin="10px">
            <h4>AENSA ECUADOR</h4>
            <h5>
              Fecha Reporte: {dateFormated}&nbsp; {dateObject.getHours().toLocaleString("en-IN")}:
              {dateObject.getMinutes().toLocaleString("en-IN")}
            </h5>
            <h6>
              Reporte Generado por:&nbsp;{_userData.name + " " + _userData.lastName}&nbsp;&nbsp;
              Empresa: &nbsp;{_userData.company.name}
            </h6>
          </td>
        </tr>
      </table>
      <br></br>
      <h6>{String(name).replaceAll("_", " ")}</h6>
    </div>
  );
};

const pdfJSXTable = (rowsData, columnNames) => {
  var tableStyle = {
    border: "0px solid grey",
    width: "100%",
    textAlign: "left",
    borderCollapse: "collapse",
  };
  var headerStyle = {
    fontSize: "10px",
    paddingLeft: "2px",
    paddingRight: "2px",
    paddingBottom: "2px",
    paddingTop: "2px",
  };
  const rowStyle = (index) => {
    return {
      backgroundColor: index % 2 === 0 ? "#f2f2f2" : "",
    };
  };

  const cellStyle = () => {
    return {
      fontSize: "9px",
      paddingLeft: "2px",
      paddingRight: "2px",
      paddingBottom: "2px",
      paddingTop: "2px",
    };
  };
  return (
    <div>
      <br></br>
      <table style={tableStyle}>
        {columnNames.map((el) => {
          {
            return <th style={headerStyle}>{el}</th>;
          }
        })}
        {rowsData.map((row, index) => {
          {
            return (
              <tr style={rowStyle(index)}>
                {Object.keys(row).map((cel) => {
                  {
                    return <td style={cellStyle()}>{row[cel]}</td>;
                  }
                })}
              </tr>
            );
          }
        })}
      </table>
    </div>
  );
};

export function generatePDF(data, name) {
  // Choose the element id which you want to export.
  const pages = [];
  const columnNames = Object.keys(data[0]);
  const dataChunks = data.reduce((all, one, i) => {
    const ch = Math.floor(i / MaxNumberRecords);
    all[ch] = [].concat(all[ch] || [], one);
    return all;
  }, []);

  dataChunks.forEach((_data) => {
    pages.push(ReactDOMServer.renderToString(pdfJSXTable(_data, columnNames)));
  });

  const header = ReactDOMServer.renderToString(pdfJsxHeader(name));

  var opt = {
    margin: 1,
    filename: name + ".pdf",
    pagebreak: { avoid: ["tr", "td"] },
    image: { type: "jpeg", quality: 1 },
    html2canvas: {
      dpi: 192,
      scale: 4,
      letterRendering: true,
      useCORS: true,
    },
    jsPDF: {
      unit: "cm",
      format: "letter",
      orientation: columnNames.length > 6 ? "landscape" : "portrait",
      precision: "12",
    },
  };
  //{ unit: 'in', format: 'letter', orientation: 'portrait' }
  // choose the element and pass it to html2pdf() function and call the save() on it to save as pdf.
  let worker = html2pdf()
    .set(opt)
    .from(header + pages[0])
    .toPdf();

  pages.slice(1).forEach((page) => {
    worker = worker
      .get("pdf")
      .then(function (pdf) {
        pdf.addPage();
      })
      .from(page)
      .toContainer()
      .toCanvas()
      .toPdf();
  });
  worker.save();
}

export function generatePdfJsPdf() {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "in",
    format: [4, 2],
  });

  doc.text("Hello world!", 1, 1);
  doc.save("two-by-four.pdf");
}
